import { useApi, createApiHook } from "../utils/apiUtils";

const useAssignappAdvancePhase = () => {
  const { apiPost } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const advancePhase = async (assignappId) => {
    if (!assignappId) {
      const response = {
        data: null,
        error: { message: "assignappId es requerido" },
      };
      setResponse(response);
      return response;
    }

    startLoading();
    const response = await apiPost(`/assignapps/${assignappId}/advance_phase`, "Error al avanzar de fase en la asignación", {});
    setResponse(response);
    return response;
  };

  return { advancePhase, data, error, loading };
};

export default useAssignappAdvancePhase;
